import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { RiderService } from 'app/core/services/rider.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-rider-current-residence',
  templateUrl: './rider-current-residence.component.html',
  styleUrls: ['./rider-current-residence.component.scss']
})

export class RiderCurrentResidenceComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  permanentResidence = false;
  pSearchlocation = false;
  searchlocation = false;
  initForm = false;
  formLocation: FormGroup;
  dataFormPermanet = {};
  dataFormRecidence = {};
  subscription: Subscription[] = [];

  @Input() formResidence: FormGroup;
  @Input() riderId: number;

  private permanet = {
    pstreetaddress : '',
    pcity          : '',
    pstate         : '',
    pzip           : '',
    platitude      : '',
    plongitude     : '',
    plocation      : '',
    pcounty         : '',
    proomaptnumber : ''
  };

  private recidence = {
    streetaddress : '',
    city          : '',
    state         : '',
    zip           : '',
    latitude      : '',
    longitude     : '',
    location      : '',
    county        : '',
    roomaptnumber : ''

  };

  get locationpForm(): AbstractControl {
    return this.formLocation.get('locationp');
  }

  get permatentResidenceCtrl(): AbstractControl {
    return this.formResidence.get('_permatentResidence');
  }

  constructor(
    private fb: FormBuilder,
    private riderService: RiderService,
  ) {
  }

  ngOnInit() {
    this.createForm();
    this.initSubscriptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['riderId']) {
      this.evalNewRider(this.riderId);
    }
  }

  ngAfterViewInit(): void {
  this.initForm = true;
  }

  initSubscriptions(): void {
    this.subscription.push(
      this.riderService.riderInformation$.subscribe((rider) => {
        if (rider) {
          this.datareview(rider);
        }
      })
    );
  }

  /**
   *@name createForm
   * @description Crea formulario para las direcciones
   * */
  createForm() {
    this.formLocation = this.fb.group({
      location: '',
      locationp: ''
    });
    this.listenControl('location');
    this.listenControl('locationp');
    this.listenControlInput('_permatentResidence');
  }

  /**
   *@name datareview
   * @description verifica los datos y los pasa al formulario
   * @param data = Object
   * */
  datareview(data: Object): void {
    if (data) {
      Object.getOwnPropertyNames(this.recidence).forEach(key => {
        this.dataFormRecidence[key] = data[key] ? data[key] : '';
      });
      if (this.verifyRecidence(this.dataFormRecidence)) {
        this.loadLocation(true, this.dataFormRecidence);
      }
      Object.getOwnPropertyNames(this.permanet).forEach(key => {
        this.dataFormPermanet[key] = data[key] ? data[key] : '';
      });
      if (this.verifyRecidence(this.dataFormPermanet)) {
        this.loadLocationp(true, this.dataFormPermanet);
      }

      this.permanentResidenceOpen();
    }
  }

  permanentResidenceOpen(): void {
    const FORM_DATA = this.locationpForm.value;
    if (FORM_DATA) {
      if (FORM_DATA.streetaddress.trim() !== '') {
        this.permatentResidenceCtrl.patchValue(true);
      } else {
        this.permatentResidenceCtrl.patchValue(false);
      }
    }
  }

  /**
   *@name evalNewRider
   * @description verifica si esta editando o creando un rider
   * @param value = riderId
   * */
  evalNewRider(value) {
    if (value === 0 && this.initForm) {
      this.formLocation.patchValue({location: this.recidence });
    }
  }

  /**
   *@name verifyRecidence
   * @description verifica si esta prensente el control
   * @param obj = Objeto - name = nombre de la key
   * */
   verifyRecidence(obj: Object, name?: string): boolean {
     let vali = true;
     if (name) {
       Object.getOwnPropertyNames(obj).forEach( val => {
         if (val === name || Object.keys(obj).length === 7) {vali = false; }
       });
     }else {
       vali = false;
      if (Object.keys(obj).length === 9) { vali = true; }
     }
     return vali;
   }

  /**
   *@name deleteData
   * @description elimina la data del objeto
   * @param isRecidence = si es recidencia o permanent
   * */
  deleteData(isRecidence: Boolean): void {
    if (isRecidence) {
      Object.keys(this.recidence).forEach(val => {
        delete this.dataFormRecidence[val];
      });
    }else {
      Object.keys(this.permanet).forEach(val => {
        delete this.dataFormPermanet[val];
      });
    }
  }

  /**
   *@name listenControl
   * @description escucha los cambios del control del form y los pasa al papa
   * @param control = campo del form
   * */
  private listenControl(control: string): void {
    this.subscription.push(
      this.formLocation.controls[control].valueChanges.subscribe(value => {
        control === 'location' ? this.loadLocation(false, value) : this.loadLocationp(false, value);
       })
    );
  }

  /**
   *@name listenControlInput
   * @description escucha los cambios del contro del form papa
   * @param control = campo del form
   * */
  private listenControlInput(control: string): void {
    if (this.formResidence.get(control).value) {
      this.permanentResidence = true;
      this.pSearchlocation = true;
    }
    this.subscription.push(
      this.formResidence.controls[control].valueChanges
      .subscribe(value => {
        this.permanentResidence = value;
        this.pSearchlocation = value;
      })
    );
  }

  /**
   *@name loadLocation
   * @description Pasa el value al Form del papa
   * */
  private loadLocation(entry: boolean, value): void {
    if (entry) {
      const locationValue = {
        streetaddress: value.streetaddress,
        city: value.city,
        state: value.state,
        zip: value.zip,
        latitude: value.latitude,
        longitude: value.longitude,
        location: value.location,
        county: value.county,
        roomaptnumber: value.roomaptnumber
      };
      this.formLocation.controls['location'].patchValue(locationValue);
      this.deleteData(true);
    } else {
      this.formResidence.patchValue({
        streetaddress      : value.streetaddress,
        city               : value.city,
        state              : value.state,
        zip                : value.zip,
        latitude           : value.latitude,
        longitude          : value.longitude,
        location           : value.location,
        county             : value.county,
        roomaptnumber      : value.roomaptnumber
      });
    }
  }

  /**
   *@name loadLocationp
   * @description Pasa el value al Form del papa
   * */
  private loadLocationp(entry: boolean, value): void {
    if (entry) {
      const locationpValue = {
        streetaddress :      value.pstreetaddress,
        city          :      value.pcity,
        state         :      value.pstate,
        zip           :      value.pzip,
        latitude      :      value.platitude,
        longitude     :      value.plongitude,
        location      :      value.plocation,
        county        :      value.pcounty,
        roomaptnumber :      value.proomaptnumber
      };
      this.formLocation.controls['locationp'].patchValue(locationpValue);
      this.deleteData(false);
    } else {
      const patchValue = Object.assign({}, value);
      delete patchValue.alternatephonenumber;
      delete patchValue.homephonenumber;
      delete patchValue.phonenumber;
      this.formResidence.patchValue({
        pstreetaddress      : patchValue.streetaddress,
        pcity               : patchValue.city,
        pstate              : patchValue.state,
        pzip                : patchValue.zip,
        platitude           : patchValue.latitude,
        plongitude          : patchValue.longitude,
        plocation           : patchValue.location,
        pcounty             : patchValue.county,
        proomaptnumber      : patchValue.roomaptnumber
      });
    }
  }

  get isInactive(): boolean {
    return this.formResidence.get('isinactive').value;
  }

  ngOnDestroy() {
    this.riderService.getDataRider(null);
    this.subscription.forEach((item) => item.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-current-residence/rider-current-residence.component.ts